import { forwardRef, ReactNode } from 'react';

import { Text } from './Typography.styled';
import { isVariantWithTag, tagsMap, VariantType } from './Typography.types';

interface TypographyProps {
  children: ReactNode;
  customAs?: string;
  variant?: VariantType;
  maxLines?: number;
}

const Typography = forwardRef<HTMLParagraphElement, TypographyProps>(
  function Typography(
    { children, variant = 'body1', customAs, ...extraStyling },
    ref,
  ) {
    // prop customAs - required to deep pass "as" component through many styled() extends:
    // https://github.com/styled-components/styled-components/issues/2129
    const as =
      customAs || (isVariantWithTag(variant) ? tagsMap[variant] : undefined);

    return (
      <Text
        as={as}
        variant={variant}
        ref={ref}
        {...extraStyling}
      >
        {children}
      </Text>
    );
  },
);

export default Typography;
